import React, { useEffect, useState } from 'react';
import { useModalsContext } from 'ModalsContext';
import { SizeableRoundedDialog as Dialog } from 'library';
import BusinessDateAndTimePage from './components/pages/DateAndTimePage/BusinessDateAndTimePage';
import BusinessJobHeadlinePage from './components/pages/HeadlineDescriptionPage/BusinessJobHeadlinePage';
import BusinessPayPage from './components/pages/PayPage/BusinessPayPage';
import PaySetupPage from './components/pages/PaySetupPage/PaySetupPage';
import { useJobFormContext, JobFormContextProvider } from './JobFormContext';
import { useHistory } from 'react-router';
import { useUserContext } from 'UserContext';
import moment, { Moment } from 'moment';
import BusinessPaymentModelPage from './components/pages/BusinessPaymentModelPage';
import ConnectPaymentModal from 'parent-portal/payments/Components/ConnectPaymentModal';
import BusinessJobRequirementsPage from './components/pages/BusinessJobRequirementsPage/BusinessJobRequirementsPage';
import BusinessAddressSelect from './components/pages/BusinessAddressSelect';
import ShiftDetails from './components/pages/ShiftDetails/ShiftDetails';
import BusinessJobSummary from './components/pages/SummaryPage/BusinessJobSummary';
import BusinessJobSuccessPage from './components/pages/ConfirmationPage/BusinessJobSuccessPage';
import ProviderPreferencesPage from './components/pages/ProviderPreferencesPage/ProviderPreferencesPage';

function BusinessJobRequestForm() {
    const {
        form,
        reset,
        currentPage,
        createdJob,
        setPageCount,
        pastProviders,
        preferredProviders,
        setFormErrors,
    } = useJobFormContext();
    const { businessJobFormOpen, closeBusinessJobForm } = useModalsContext();
    const [showPaymentSetup, setShowPaymentSetup] = useState(false);
    const [showTandemPaySetup, setShowTandemPaySetup] = useState(false);
    const { fieldStates } = form;
    const history = useHistory();
    const { user, role } = useUserContext();
    const { setValid, setValue } = fieldStates.jobTypeId;
    const hasProviders = pastProviders.length > 0 || preferredProviders.length > 0;
    const business = user?.businesses?.length ? user.businesses[0] : null;

    useEffect(() => {
        setValue(1);
        setValid(true);
        form.fieldStates.endDate.setValue(moment() as Moment);
    }, []);

    useEffect(() => {
        if (role === 'business_active') {
            let paymentSetup = !!user?.payment_information && user?.payment_information?.length > 0;
            setShowPaymentSetup(!paymentSetup && !localStorage.getItem('old')); //TODO: need a better solution to this for admins
        }
    }, [user, role]);

    useEffect(() => {
        const addresses = user?.address;
        if (addresses?.length) {
            const mailingAddress = addresses.find((x) => x.address_type === 'PRIMARY');
            const addressId = mailingAddress ? mailingAddress.id : addresses[0].id;

            form.fieldStates.address.setValue([addressId]);
        }
    }, [user]);

    const completeFollowUps = () => {
        onClose();
        if (history.location.pathname.includes('/jobs')) history.go(0);
        else if (history.location.pathname.includes('/get-started')) history.push('/home');
    };

    const onClose = () => {
        reset();
        closeBusinessJobForm();
        setFormErrors([]);
    };

    const pages = [
        <BusinessPaymentModelPage fieldStates={fieldStates} />,
        <BusinessDateAndTimePage
            businessJobType={fieldStates.businessJobType}
            requestType={fieldStates.requestType}
            daysOfTheWeek={fieldStates.daysOfTheWeek}
            jobDate={fieldStates.jobDate}
            sameTimes={fieldStates.sameTimes}
            jobTimes={fieldStates.jobTimes}
            startDate={fieldStates.startDate}
            endDate={fieldStates.endDate}
        />,
        <BusinessJobHeadlinePage fieldStates={fieldStates} />,
        business?.business_type === 'CHILD_CARE' ? <BusinessJobRequirementsPage fieldStates={fieldStates} /> : null,
        <BusinessAddressSelect fieldStates={fieldStates} />,
        <ShiftDetails fieldStates={fieldStates} />,
        showPaymentSetup ? <PaySetupPage setShowTandemPaySetup={setShowTandemPaySetup} /> : null,
        hasProviders ? (
            <ProviderPreferencesPage
                fieldStates={fieldStates}
                title="Request Providers"
                subtitle="We will prioritize workers that you have had a good experience with in the past."
            />
        ) : null,
        <BusinessPayPage fieldStates={fieldStates} />,
        <BusinessJobSummary fieldStates={fieldStates} />,
        <BusinessJobSuccessPage job={createdJob} onClose={completeFollowUps} />,
    ].filter((item) => item !== null);

    useEffect(() => {
        setPageCount(pages.length);
    }, [pages]);

    return (
        <>
            {!showTandemPaySetup ? (
                <Dialog
                    open={businessJobFormOpen}
                    onClose={createdJob ? completeFollowUps : onClose}
                    closeButton
                    style={{ width: '60%', maxWidth: 643, maxHeight: '95vh' }}
                    contentStyle={{ marginTop: 20 }}
                >
                    {pages[currentPage]}
                </Dialog>
            ) : null}
            <ConnectPaymentModal
                isOpen={showTandemPaySetup}
                onClose={() => setShowTandemPaySetup(false)}
                fromRoute={'BusinessJobRequestModal'}
            />
        </>
    );
}

export default function BusinessJobFormWithContext() {
    const { role } = useUserContext();
    if (role && role !== 'admin') {
        return (
            <JobFormContextProvider>
                <BusinessJobRequestForm />
            </JobFormContextProvider>
        );
    }
    return null;
}
